import { Injectable, inject } from "@angular/core";

import { ApiService } from "@tylertech/core-module";
import { COContact, IContact, IdValuePair, MailingAddressViewModel } from "@tylertech/tyler-api-types";

import { EntityAlertCode } from "../interfaces/entityAlertCode";

@Injectable()
export class ContactService
{
    private readonly $apiService = inject(ApiService);


    UpdateMailingAddresses(mailingAddresses: MailingAddressViewModel[]): Promise<MailingAddressViewModel[]>
    {
        // TODO - we are serializing the data ourselves?
        return this.$apiService.sendAuth<string, MailingAddressViewModel[]>("IContactService/UpdateMailingAddresses", JSON.stringify(mailingAddresses)
        );
    }

    addContact(contact: COContact): Promise<COContact>
    {
        return this.$apiService.sendAuth<COContact, COContact>("IContactService/AddContact", contact);
    }

    certifyMailingAddress(addressJson: string): Promise<MailingAddressViewModel>
    {
        return this.$apiService.sendAuth<string, MailingAddressViewModel>("IContactService/CertifyMailingAddress", addressJson);
    }

    checkForMatchingSSN(ssn: string): Promise<string>
    {
        return this.$apiService.sendAuth<string, string>("IContactService/CheckForMatchingSSN", ssn);
    }

    getAlertCodes(): Promise<EntityAlertCode[]>
    {
        return this.$apiService.sendAuth<string, EntityAlertCode[]>("IContactService/GetAlertCodes");
    }

    getContactFull(contactId: string): Promise<COContact>
    {
        return this.$apiService.sendAuth<string, COContact>("IContactService/GetContactFull", contactId);
    }

    getContactFullWithRequestInfoAdded(contactId: string, requestId: string): Promise<COContact>
    {
        // TODO - we are serializing the data ourselves?
        return this.$apiService.sendAuth<string, COContact>("IContactService/GetContactFullWithRequestInfoAdded", JSON.stringify([contactId, requestId]));
    }

    getContactSets(): Promise<IdValuePair[]>
    {
        return this.$apiService.sendAuth<string, IdValuePair[]>("IContactService/GetContactSets");
    }

    getMailingAddressCitySuggestions(): Promise<MailingAddressViewModel[]>
    {
        return this.$apiService.sendAuth<string, MailingAddressViewModel[]>("IContactService/GetSuggestionCities");
    }

    getMailingAddressesByContactId(contactId: string): Promise<MailingAddressViewModel[]>
    {
        return this.$apiService.sendAuth<string, MailingAddressViewModel[]>("IContactService/GetMailingAddressesByContactId", contactId);
    }

    getNewContactForUbRequest(requestId: string): Promise<COContact>
    {
        return this.$apiService.sendAuth<string, COContact>("IContactService/GetNewContactForUbRequest", requestId);
    }

    getShowCertify(): Promise<boolean>
    {
        return this.$apiService.sendAuth<string, boolean>("IContactService/ShowCertify");
    }

    getSuffixes(): Promise<string[]>
    {
        return this.$apiService.sendAuth<string, string[]>("IContactService/GetSuffixes");
    }

    getTitles(): Promise<string[]>
    {
        return this.$apiService.sendAuth<string, string[]>("IContactService/GetTitles");
    }

    parseIndividualName(individualFullName: string): Promise<IContact>
    {
        return this.$apiService.sendAuth<string, IContact>("IContactService/ParseIndividualName", individualFullName);
    }

    updateContact(contact: COContact): Promise<COContact>
    {
        return this.$apiService.sendAuth<COContact, COContact>("IContactService/UpdateContact", contact);
    }

    updateContactMailingAddresses(contact: COContact): Promise<boolean>
    {
        return this.$apiService.sendAuth<COContact, boolean>("IContactService/UpdateContactMailingAddresses", contact
        );
    }
}
